/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_URL, API_SCT, API_SERVER } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');

    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [pdf, set_pdf] = useState('');
    const [pdf_progress, set_pdf_progress] = useState(false);
    const [data, set_data] = useState(null)
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/

    const _compressor = (fileParams) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", STORAGE_USER[0].bamboo);

        fileParams.map((item) => (
            data.append("file", item)
        ))

        var config = {
            method: 'post',
            url: API_URL + "compress/pdf__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                set_pdf_progress(true)
                progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                set_data(response.data.data)
                error(response.data.title)
                set_pdf_progress(false)
                document.getElementById("compress").value = "";
            } else if(response.data.error){
                error(response.data.error)
                set_pdf_progress(false)
                document.getElementById("compress").value = "";
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
            set_pdf_progress(false)
            document.getElementById("compress").value = "";
        })
        .finally(() => {
            loading(false);
            set_pdf_progress(false)
            document.getElementById("compress").value = "";
		})

    }

    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [FILES]
    ----------------------------------------------------------------*/
    const _files_pdf = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }

        console.log('file', event.target.files)

        const data = [...event.target.files]

        if(event){
            if(event.target.files.length > 0){
                
                // console.log('push : ', data)

                data.map((item, index) => {
                    // console.log('item', data)
                    if(item.size > 10485760){
                        return error('Ukuran File maxsimal 10MB')
                    }else if (item.type !== 'application/pdf'){
                        return error('Extensi Tidak Didukung')
                    }else{
                        error('')
                        set_data(null)
                        _compressor([...data])
                    }

                })

            }
        }

        // let foo = event.target.files[0]; 

	};
    /*--------------------------------------------------------------
    [End FILES]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

    }, [refresh])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        <div style={{margin: -20}}>
            {
                pdf_progress &&
                <div style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 999999, backgroundColor: '#fff', padding: 20}}>
                    <div className="_position_middle">
                        <div className="_center_align">
                            <ReactLoading type={'cylon'} color={'#444'} height={40} width={40} />
                        </div>
                        <h1 className="_push_b_m">Compress</h1>
                        <div className="_center_text" style={{maxWidth: 400, marginLeft: 'auto', marginRight: 'auto'}}>
                            <p>File Sedang Dikompresi . . .</p>
                        </div>
                    </div>
                </div>
            }
            {
                console.log('data render', data)
            }
            <div style={{overflow: 'hidden', padding: 20}}>
                <div style={{position: 'relative', zIndex: 10}}>
                    <div className="_row _center_align">
                        <div className="_column">
                            <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Compressor</h1>
                        </div>
                    </div>
                    <div className="_row _center_align _push_b_g">
                        <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                        <p className="_push_l_m">Kompresi File Menjadi Lebih Kecil</p>
                    </div>
                    
                    <p className="_push_b_s">Pilih file atau drop kesini <span className="_badge_green _push_l_t">pdf</span></p>
                </div>
                <div className="_bb_file_uploads _push_t_d" style={{height: 400}}>
                    <div style={{position: 'absolute', top: 10, right: 10, bottom: 10, left: 10, zIndex: -1, backgroundColor: '#f9f9fa'}}>
                        <div className="_position_middle">
                            <ion-icon name="balloon-outline" style={{fontSize: 100}}></ion-icon>
                            <p className="_push_t_d">Pilih Data atau drop disini</p>
                        </div>
                    </div>
                    <input
                        id="compress"
                        multiple
                        className="_custom_file_input_drop" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files_pdf}
                    />
                </div>
                <br/>
                <br/>
                <div className="_row_auto _center_align">
                    {
                        data && data.length > 0 &&
                        data.map((item, index) => (
                            <a href={API_SERVER + '/' + 'modify/' + STORAGE_USER[0].bamboo + '/' + item} className="_btn _push_r_m">
                                File {index + 1}
                            </a>

                        ))   
                    }
                </div>
                     
            </div>
        </div>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;